"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrors = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("./ValidationErrors.scss");
/**
 * ValidationErrors component that displays a list of validation errors
 * @param props - ValidationErrorsProps
 * @returns ValidationErrors component
 */
const ValidationErrors = ({ errors, title = 'Validation Errors', }) => {
    if (errors.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "validation-errors", role: "alert", children: [(0, jsx_runtime_1.jsx)("h3", { className: "validation-errors__title", children: title }), (0, jsx_runtime_1.jsx)("ul", { className: "validation-errors__list", children: errors.map((error) => ((0, jsx_runtime_1.jsx)("li", { className: `validation-errors__item validation-errors__item--${error.type || 'error'}`, children: error.message }, error.id))) })] }));
};
exports.ValidationErrors = ValidationErrors;
exports.default = exports.ValidationErrors;
